import { render, staticRenderFns } from "./MatterInfo.vue?vue&type=template&id=0fd4faec&scoped=true"
import script from "./MatterInfo.vue?vue&type=script&lang=js"
export * from "./MatterInfo.vue?vue&type=script&lang=js"
import style0 from "./MatterInfo.vue?vue&type=style&index=0&id=0fd4faec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4faec",
  null
  
)

export default component.exports